// extracted by mini-css-extract-plugin
export default {"calcContainer":"component_calcContainer__m9AIP","calcDisplay":"component_calcDisplay__Ucs0w","calcButtons":"component_calcButtons__gkrd8"};